var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-card shadow-sm overflow-hidden"},[_c('div',{staticClass:"card-icon"},[_vm._t("icon")],2),_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_vm._t("default")],2),_c('p',{staticClass:"card-subtitle"},[_vm._t("subtitle")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }